import styled, { css } from 'styled-components';
import colors from 'Styles/colors';

const Wrapper = styled.div`
  flex: 0 0 auto;
  min-width: 69px;
  padding: 0 12px;
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
  height: 25px;
  color: ${colors.white};
  ${({ value }) => (value === 'offline'
    ? css`
        background: ${colors.blueGrey};
      `
    : css`
        background: ${colors.blueCerulean};
      `)}
`;

export default Wrapper;
